import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const UserModule = {
  namespaced : true,
  state      : {
    //- Selected User for user details
    selUser: null,
    initiator: null
  },
  getters,
  actions,
  mutations
}

export default UserModule